import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home, PanelLeftClose, PanelLeftOpen } from 'lucide-react';
import { ThemeToggle } from './ThemeToggle';
import { UnitSwitcher } from './UnitSwitcher';
import { ActivePeriodoLetivoSwitcher } from './ActivePeriodoLetivoSwitcher';
import { NotificationsPopover } from './NotificationsPopover';
import { UserNav } from './UserNav';
import { Separator } from '@/components/ui/separator';
import { Button } from '@/components/ui/button';
import { useSidebar } from '@/contexts/SidebarContext';
import { rotulosBreadcrumb } from '@/utils/breadcrumbLabels';

export const Header = () => {
  const location = useLocation();
  const itens = rotulosBreadcrumb(location.pathname, location.search);
  const { colapsada, alternar } = useSidebar();

  return (
    <header className="sticky top-0 z-40 w-full border-b bg-background/80 backdrop-blur-md">
      <div className="flex h-16 items-center justify-between px-4 md:px-6">
        {/* Toggle sidebar (desktop) + Breadcrumbs */}
        <div className="flex items-center gap-2 min-w-0">
          <Button
            variant="ghost"
            size="icon"
            onClick={alternar}
            className="hidden md:inline-flex h-9 w-9 shrink-0"
            aria-label={colapsada ? 'Expandir menu lateral' : 'Retrair menu lateral'}
            aria-pressed={colapsada}
            title={colapsada ? 'Expandir menu' : 'Retrair menu'}
          >
            {colapsada ? <PanelLeftOpen className="h-4 w-4" /> : <PanelLeftClose className="h-4 w-4" />}
          </Button>

          <nav
            className="flex items-center space-x-1 text-sm text-muted-foreground min-w-0 overflow-hidden"
            aria-label="Breadcrumb"
          >
            <Link
              to="/"
              className="flex items-center shrink-0 hover:text-foreground transition-colors"
            >
              <Home className="h-4 w-4 mr-1" />
              <span className="hidden md:inline">Início</span>
            </Link>
            {itens.map((item, index) => {
              const isLast = index === itens.length - 1;
              return (
                <div key={item.key} className="flex items-center min-w-0">
                  <ChevronRight className="h-4 w-4 mx-1 shrink-0" />
                  {isLast ? (
                    <span className="truncate whitespace-nowrap font-medium text-foreground">
                      {item.label}
                    </span>
                  ) : (
                    <Link
                      to={item.path}
                      className="truncate whitespace-nowrap hover:text-foreground transition-colors"
                    >
                      {item.label}
                    </Link>
                  )}
                </div>
              );
            })}
          </nav>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-2 shrink-0">
          <UnitSwitcher />
          <ActivePeriodoLetivoSwitcher />
          <Separator orientation="vertical" className="mx-1 h-6 hidden md:block" />
          <ThemeToggle />
          <NotificationsPopover />
          <Separator orientation="vertical" className="mx-2 h-6 hidden md:block" />
          <UserNav />
        </div>
      </div>
    </header>
  );
};
